import React from 'react';
import iconTemplate from './IconTemplate';

export default iconTemplate(
    <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="-0.625 -0.625 24 24"
        id="Cloud-Upload--Streamline-Flex"
        height="24"
        width="24"
    >
        <g id="cloud-upload--cloud-server-internet-upload-up-arrow-network">
            <path
                id="Subtract"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M4.646378749999999 15.183853749999999C2.51876625 14.283359999999998 0.8125 12.6821175 0.8125 9.83783125c0 -3.31673875 1.8656624999999998 -5.18240125 5.18240125 -5.18240125l0.06436625 0.00022749999999999997C6.7859025 2.1726575 8.80776 0.8125 11.887525 0.8125c3.75363625 0 5.9358 2.02050875 6.1166625 5.63184375 2.519075 0.04395625 3.9333125 1.4973400000000001 3.9333125 4.05068625 0 2.71802375 -1.6732625 4.17274 -3.7259625 4.9504975"
                strokeWidth="1.25"
            ></path>
            <path
                id="Vector"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M8.14796125 16.2942c1.15986 -1.4156025 1.8671087499999999 -2.1229812499999996 3.22661625 -3.226535 1.3595075 1.1035537499999999 2.0667400000000002 1.8109324999999998 3.22661625 3.226535"
                strokeWidth="1.25"
            ></path>
            <path
                id="Vector_2"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="m11.374934999999999 21.6776625 0 -8.59298375"
                strokeWidth="1.25"
            ></path>
            <path
                id="Vector 2591"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M5.9445749999999995 4.658095c1.9136324999999998 0 3.6250662499999997 1.261325 4.16494 2.4136937499999997"
                strokeWidth="1.25"
            ></path>
        </g>
    </svg>,
) as React.FC;
